import type { SafeAreaContextType, SafeAreaInsets } from "./types";

export function setSafeAreaInsets(
    context: SafeAreaContextType,
    insets: Partial<SafeAreaInsets>,
): SafeAreaContextType {
    const fullfilled = fullfillSafeAreaInsets(insets);
    return {
        current: {
            top: fullfilled.top,
            bottom: fullfilled.bottom,
            left: fullfilled.left,
            right: fullfilled.right,
        },
        cumulated: {
            top: context.cumulated.top + fullfilled.top,
            bottom: context.cumulated.bottom + fullfilled.bottom,
            left: context.cumulated.left + fullfilled.left,
            right: context.cumulated.right + fullfilled.right,
        },
    };
}

export function substractSafeAreaInsets(
    context: SafeAreaContextType,
    insets: Partial<SafeAreaInsets>,
): SafeAreaContextType {
    const fullfilled = fullfillSafeAreaInsets(insets);
    return {
        current: {
            top: context.current.top - fullfilled.top,
            bottom: context.current.bottom - fullfilled.bottom,
            left: context.current.left - fullfilled.left,
            right: context.current.right - fullfilled.right,
        },
        cumulated: context.cumulated,
    };
}

export function fullfillSafeAreaInsets(insets: Partial<SafeAreaInsets>): SafeAreaInsets {
    return {
        top: insets.top || 0,
        bottom: insets.bottom || 0,
        left: insets.left || 0,
        right: insets.right || 0,
    };
}

export function getEmptySafeAreaInsets() {
    return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    };
}

export function getEmptySafeAreaContext() {
    return {
        current: getEmptySafeAreaInsets(),
        cumulated: getEmptySafeAreaInsets(),
    };
}
